var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component, Watch } from "vue-facing-decorator";
import { EventTypesClient, CompaniesClient, GetEventTypeListPaginatedQuery, PaginatedEnumerableOfEventTypeModel, SortDescription, SortDirection } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { CacheHelper } from "@/app/utils/cache-helper";
import Sorter from "@/common/utils/sorter";
import RouteNames from "@/app/router/routes";
import { DataGridStateHelper } from "@/app/utils/data-grid-state-helper";
const companyClient = new CompaniesClient(window.apiUrl);
const eventTypesClient = new EventTypesClient(window.apiUrl);
let EventTypesVue = class EventTypesVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.searchAttempted = false;
        this.companies = [];
        // components
        this.sorter = new Sorter(new SortDescription({
            fieldName: "EventTypeName",
            direction: SortDirection.Ascending
        }));
        this.query = new GetEventTypeListPaginatedQuery({
            companyId: 0,
            keywords: "",
            pageNo: 1,
            pageSize: 100,
            includeDeleted: false,
            sort: this.sorter.currentSort,
        });
        this.data = new PaginatedEnumerableOfEventTypeModel();
        this.columns = [
            { visible: true, fieldName: "eventTypeName", title: "Name" },
            { visible: true, fieldName: "scopeName", title: "Scope" },
            { visible: true, fieldName: "enabled", title: "Enabled" },
            { visible: true, fieldName: "alarmDefinitionsCount", title: "# Alarm Definitions" },
            { visible: true, fieldName: "timeWindowMinutes", title: "Time Window (min.)" },
            { visible: true, fieldName: "sendNotificationsOnFirstAlarm", title: "Notifications" },
            { visible: true, fieldName: "contactNames", title: "Contacts" },
        ];
    }
    created() {
        this.loadDataGridState();
        this.getCompanies();
    }
    ;
    getCompanies() {
        return __awaiter(this, void 0, void 0, function* () {
            this.working = true;
            return yield companyClient
                .getListGET()
                .then(response => {
                let companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || ""
                    };
                });
                this.companies = companies;
                if (!companies.length)
                    return;
                this.working = false;
                this.restoreCachedFilters();
                if (!this.query.companyId)
                    this.company = companies[0];
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    search() {
        if (this.working)
            return;
        if (!this.query)
            return;
        this.working = true;
        eventTypesClient
            .search(this.query)
            .then((response) => {
            this.data = new PaginatedEnumerableOfEventTypeModel();
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    onDataGridStateChanged() {
        DataGridStateHelper.storeDataGridState("event-type-grid", this.columns, this.sorter, this.query.includeDeleted);
    }
    onSortChanged() {
        this.query.sort = this.sorter.currentSort;
        if (!this.working) {
            this.onDataGridStateChanged();
            this.search();
        }
    }
    ;
    edit(eventType) {
        this.$router.push({ name: RouteNames.EventType, params: { companyId: this.query.companyId, id: eventType.eventTypeId.toString() } });
    }
    ;
    archive(eventType) {
        if (this.working)
            return;
        this.$confirmModal.show("Are you sure that you want to archive this event type?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            eventTypesClient
                .delete(eventType.eventTypeId)
                .then(() => {
                eventType.whenDeleted = new Date();
                Notifier.onOk(`Event Type ${eventType.eventTypeName} has been successfully archived.`);
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    restore(eventType) {
        if (this.working)
            return;
        this.working = true;
        eventTypesClient
            .restore(eventType.eventTypeId)
            .then(() => {
            eventType.whenDeleted = undefined;
            Notifier.onOk(`Event Type ${eventType.eventTypeName} has been successfully restored.`);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    cacheFilters() {
        CacheHelper.storeItem(RouteNames.EventTypes, "CompanyId", String(this.query.companyId));
    }
    restoreCachedFilters() {
        var companyId = CacheHelper.getItem(RouteNames.EventTypes, "CompanyId");
        if (companyId)
            this.query.companyId = companyId;
    }
    // Computed
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    ;
    closeColumnSettingsMenu() {
        let dropdown = this.$refs.columnSettingsDropdown;
        dropdown.close(true);
    }
    ;
    get numberOfVisibleColumns() {
        return this.columns.filter(column => column.visible).length;
    }
    ;
    isVisible(name) {
        let column = this.columns.filter(column => {
            return column.fieldName.toLowerCase() == name.toLowerCase();
        })[0];
        return column ? column.visible : false;
    }
    ;
    loadDataGridState() {
        this.working = true;
        try {
            var state = DataGridStateHelper.loadDataGridState("event-type-grid", this.columns, this.sorter);
            if (state != null) {
                this.query.includeDeleted = state.includeDeleted;
            }
        }
        finally {
            this.working = false;
        }
    }
    getNotificationText(eventType) {
        if (!eventType.sendEmail && !eventType.sendSms)
            return "Don't send notifications";
        else if (eventType.sendEmail && !eventType.sendSms)
            return "Send emails";
        else if (!eventType.sendEmail && eventType.sendSms)
            return "Send SMS";
        return "Send emails and SMS";
    }
    getContactNamesTitle(eventType) {
        var _a;
        return (_a = eventType === null || eventType === void 0 ? void 0 : eventType.contactNames) === null || _a === void 0 ? void 0 : _a.join("\r\n");
    }
    getContactNames(eventType) {
        var _a;
        return (_a = eventType === null || eventType === void 0 ? void 0 : eventType.contactNames) === null || _a === void 0 ? void 0 : _a.join(", ");
    }
    get company() {
        return this.companies.filter(item => {
            return item.value == this.query.companyId;
        })[0] || null;
    }
    ;
    set company(item) {
        if (!item)
            return;
        this.query.companyId = item.value;
        this.cacheFilters();
    }
    ;
};
__decorate([
    Watch("query.companyId"),
    Watch("query.pageNo"),
    Watch("query.includeDeleted"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], EventTypesVue.prototype, "search", null);
__decorate([
    Watch("query.includeDeleted"),
    Watch("numberOfVisibleColumns"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], EventTypesVue.prototype, "onDataGridStateChanged", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], EventTypesVue.prototype, "onSortChanged", null);
EventTypesVue = __decorate([
    Component({
        name: "EventTypesVue"
    })
], EventTypesVue);
export default EventTypesVue;
